import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchEngageMessageById } from 'api/engage';
import { SmsMessagePreview } from 'components/message-builder/SmsMessagePreview';
import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import IframeResizer from 'iframe-resizer-react';
import { accountQueryKeys } from 'queries/account-query-keys';

interface WorkflowMessagePreviewProps {
    messageId: number;
}
const WorkflowMessagePreview = ({ messageId }: WorkflowMessagePreviewProps) => {
    const { accountId } = useCurrentAccount();
    const { apiUrl } = useAppState();

    const { data: message } = useSuspenseQuery({
        queryKey: accountQueryKeys.engageMessageById(accountId, messageId),
        queryFn: () => fetchEngageMessageById(accountId, messageId),
    });

    if (message.channel === 'sms') {
        return <SmsMessagePreview message={message} />;
    }

    if (message.channel === 'email') {
        return (
            <IframeResizer
                autoResize={false}
                className="min-h-96 w-full"
                src={`${apiUrl}/dashboard/accounts/${accountId}/messages/${messageId}/preview`}
            />
        );
    }

    return null;
};

export { WorkflowMessagePreview };
